import I18N_DOMAIN_COMPONENTS from '../constants';
import getLocale from './DateFnsLocale/locale';

export default {
	namespace: I18N_DOMAIN_COMPONENTS,
	getDateFnsLocale: getLocale,
};
